import styled from 'styled-components';

import { breakpoints } from '../../theme';

interface ColProps {
  md?: number;
  sm?: number;
  debug?: boolean;
}

export const Container = styled.div`
  margin: 150px auto;
  width: 80%;
  @media (${breakpoints.sm}) {
    width: 100%;
  }
`;

export const Grid = styled.div``;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const Col = styled.div<ColProps>`
  // background-color: ${({ debug, theme }) => debug && theme.colors.lightGray};
  outline: ${({ debug }) => (debug ? '1px dashed silver' : undefined)};
  flex: ${({ md }) => md || 1};
  align-content: center;
  @media (${breakpoints.sm}) {
    flex: ${({ sm }) => (sm ? sm : 1)};
  }
`;
